import { Vue } from 'vue-property-decorator';
import {http} from '@/providers/apis/http';
import { demoUserSerializer } from '@/providers/serializers/demo-user/demo-user';
import StaticAssetsMixin from '@/helpers/mixins/static-assets-mixin';

/**
 * Class help to fetch demo user roles
 */
export class DemoUser extends Vue {

    private static INSTANCE = new DemoUser();

    static get instance() {
        return this.INSTANCE;
    }

    private nucleusNamespace: string = 'api/nucleus/v1';

    private namespace: string = 'stubs';

    /**
     * Help to fetch roles list from the json
     */
    public fetchDemoAccounts() {
        const endpoints = `${window.location.origin}/${this.namespace}/demo-accounts.json`;
        const headers = http.getTokenHeaders();

        return http.get(endpoints, headers).then((response) => {
            return response.data;
        });
    }

    public userAppList() {
        const isMygooru = new StaticAssetsMixin().isMygooruHost();
        const endpoint = `${this.nucleusNamespace}/rbac/users/apps?suite=${
            isMygooru ? 'mygooru' : 'gooru'
          }`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return demoUserSerializer.serializeAppList(response.data);
        });
    }

}

export const demoUser = DemoUser.instance;
